import { theme } from '../globalStyles';
import { hexToRgb, pxToRem } from './utils';

export const focusBoxShadow = `0 0 0 3px rgba(91,140,214, 0.5)`;

export const addFocusStyle = () => `  
  outline: none;

  body.tabbing & {
    box-shadow: ${focusBoxShadow};
  }
`;

export const addPanelStyle = () => `
  background-color: ${theme.colors.b};
  border-radius: ${pxToRem(4)};
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(16)} rgba(${hexToRgb(theme.colors.a)}, 0.08);
`;

export const addInputStyle = (vPadding = 10) => `
  padding: ${pxToRem(vPadding)} ${pxToRem(12)};
  background-color: ${theme.colors.b};
  border: 1px solid ${theme.colors.c};
  border-radius: 100rem;
  box-sizing: border-box;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
`;
